"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @hidden Internal method which resolves all given contexts to corresponding stores
 */
exports.resolveStores = function (contexts) {
    if (contexts === void 0) { contexts = {}; }
    return Object.keys(contexts).reduce(function (obj, key) {
        var _a;
        return __assign({}, obj, (_a = {}, _a[key] = React.useContext(contexts[key]), _a));
    }, {});
};
/**
* @hidden Internal method which resolves all given middlewares, provides injected stores
*/
exports.resolveMiddleware = function (middlewareList) {
    return middlewareList !== undefined
        ? middlewareList.map(function (middleware) {
            if (isMiddlewareCreator(middleware)) {
                var _stores_1 = exports.resolveStores(middleware.contexts);
                var _middleware = function (next, args, meta) { return middleware.initMiddleware(next, args, __assign({}, meta, { stores: _stores_1 })); };
                return _middleware;
            }
            else {
                return middleware;
            }
        })
        : [];
};
/**
* @hidden Internal method which checks if provided middleware is middleware or middleware creator
*/
var isMiddlewareCreator = function (middleware) {
    return typeof middleware !== 'function';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-concise-state/dist/resolvers.js
// module id = 425
// module chunks = 0